import React from "react";

interface IconProps {
  width?: string;
  height?: string;
  color?: string; // stroke color
  fillColor?: string; // main fill color
  className?: string;
  title?: string;
}

const IconPanier: React.FC<IconProps> = ({
  width = "41",
  height = "40",
  color = "#EE8113",
  fillColor = "white",
  className,
  title = "Shopping cart",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={title}
    className={className}
    {...props}
  >
    <title>{title}</title>

    {/* Cart basket */}
    <path
      d="M6 6h3.5l3 17.5A3.5 3.5 0 0016 27h13a3.5 3.5 0 003.5-3.5V13.5A3.5 3.5 0 0030.5 10H14"
      fill={fillColor}
      stroke={color}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Handle */}
    <path
      d="M5 6.7L9.3 6"
      stroke={color}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Wheel left */}
    <circle
      cx="16.5"
      cy="31"
      r="2.5"
      fill={fillColor}
      stroke={color}
      strokeWidth={1.6}
    />

    {/* Wheel right */}
    <circle
      cx="28.5"
      cy="31"
      r="2.5"
      fill={fillColor}
      stroke={color}
      strokeWidth={1.6}
    />

    {/* Optional small badge (items count) - example decorative */}
    {/* <g transform="translate(27,2)">
      <circle cx="6" cy="6" r="6" fill={color} />
      <text
        x="6"
        y="9"
        textAnchor="middle"
        fontSize="7"
        fontFamily="Inter, Arial, sans-serif"
        fill={fillColor}
        fontWeight={600}
      >
        3
      </text>
    </g> */}
  </svg>
);

export default IconPanier;
